"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = OpenEnrollmentStatusChart;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const ThemeContext_1 = require("../ThemeContext");
const cancelable_promise_1 = require("cancelable-promise");
const BenefitRenewal_1 = __importDefault(require("../api/BenefitRenewal"));
const Loading_1 = __importDefault(require("../components/Loading"));
const UserContext_1 = require("../contexts/UserContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        bar: {
            alignSelf: 'center',
            flexDirection: 'row',
            height: 20,
            justifyContent: 'center',
            width: '100%'
        },
        legendItem: {
            alignItems: 'stretch',
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center'
        },
        legendLabel: {
            color: THEME.Text,
            fontSize: 12,
            fontWeight: '500'
        },
        legendTotal: {
            color: THEME.Text,
            fontSize: 12
        }
    });
};
function OpenEnrollmentStatusChart(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [benefitRenewalOpenEnrollment, setBenefitRenewalOpenEnrollment] = react_1.default.useState(null);
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => BenefitRenewal_1.default.getBenefitRenewalOpenEnrollment(token)))
            .then((data) => {
            setBenefitRenewalOpenEnrollment(data);
            setStatus('done');
        })
            .catch((e) => {
            setStatus(e == 404 ? 'done' : 'error');
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, [refresh]);
    const openEnrollmentTotalComplete = benefitRenewalOpenEnrollment?.employeeStatuses?.filter((employee) => employee.status?.toLowerCase() == "complete")?.length;
    const openEnrollmentTotalIncomplete = benefitRenewalOpenEnrollment?.employeeStatuses?.filter((employee) => employee.status?.toLowerCase() == "incomplete")?.length;
    const openEnrollmentTotalIneligible = benefitRenewalOpenEnrollment?.employeeStatuses?.filter((employee) => employee.status?.toLowerCase() == "ineligible")?.length;
    const total = openEnrollmentTotalComplete + openEnrollmentTotalIneligible + openEnrollmentTotalIncomplete;
    const completePercent = openEnrollmentTotalComplete > 0 ? Math.max((openEnrollmentTotalComplete / total) * 100, 2) : 0;
    const incompletePercent = openEnrollmentTotalIncomplete > 0 ? Math.max((openEnrollmentTotalIncomplete / total) * 100, 2) : 0;
    const ineligiblePercent = openEnrollmentTotalIneligible > 0 ? Math.max((openEnrollmentTotalIneligible / total) * 100, 2) : 0;
    return ((status == 'done')
        &&
            (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'column' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.bar, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                    width: `${completePercent}%`,
                                    backgroundColor: THEME.Secondary
                                }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                    width: `${ineligiblePercent}%`,
                                    backgroundColor: `${THEME.Amber}AD`,
                                    borderLeftColor: THEME.PrimaryLightest,
                                    borderLeftWidth: 2
                                }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                    width: `${incompletePercent}%`,
                                    backgroundColor: `${THEME.Gray}88`,
                                    borderLeftColor: THEME.PrimaryLightest,
                                    borderLeftWidth: 2
                                }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 } }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, flexDirection: 'row', marginVertical: 6 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.legendItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { backgroundColor: THEME.Secondary, marginRight: 6, marginTop: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 10, height: 20 } }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendLabel, children: t('company:labels.complete') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: openEnrollmentTotalComplete })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.legendItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { backgroundColor: `${THEME.Amber}AD`, marginRight: 6, marginTop: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 10, height: 20 } }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendLabel, children: t('company:labels.ineligible') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: openEnrollmentTotalIneligible })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.legendItem, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { backgroundColor: `${THEME.Gray}88`, marginRight: 6, marginTop: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 10, height: 20 } }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { accessible: true, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendLabel, children: t('company:labels.incomplete') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: openEnrollmentTotalIncomplete })] })] })] })] })
        ||
            (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() }));
}
;
